import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './HintQuestion.css';

type THintQuestionProps = {
  text: string;
  onClick(text: string): void;
};

export const HintQuestion: React.VFC<THintQuestionProps> = ({ text, onClick }) => {
  return (
    <span className={styles['container']} onClick={() => onClick(text)}>
      <UIText1 color="primary_100" whiteSpace="nowrap">
        {text}
      </UIText1>
    </span>
  );
};
